import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initializeSentry } from './lib/sentry.ts';

// Initialize Sentry before any other code
initializeSentry();

// Google OAuth Client ID - same one used in backend
const GOOGLE_CLIENT_ID =
	import.meta.env.VITE_GOOGLE_CLIENT_ID ||
	'1090790594584-eg0c8hqb29qd64glvm5f9stmpua66qu9.apps.googleusercontent.com';

// Conditionally enable StrictMode - can be disabled for debugging
const enableStrictMode = import.meta.env.VITE_ENABLE_STRICT_MODE !== 'false';

const AppComponent = (
	<GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
		<App />
	</GoogleOAuthProvider>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
	enableStrictMode ? <React.StrictMode>{AppComponent}</React.StrictMode> : AppComponent
);
